export default {
  entryAction: {
    groupButton: 'group-entry-action-button',
    cancelGroupButton: 'group-entry-cancel-action-button',
  },
  coachmark: {
    container: 'group-coachmark',
    gotItButton: 'group-coachmark-got-it',
    pointer: 'group-coachmark-pointer',
    spotlight: 'group-coachmark-spotlight',
  },
  panel: {
    container: 'group-panel',
    backButton: 'group-panel-back',
    closeButton: 'group-panel-close',
    userCheckbox: 'group-panel-user-checkbox',
    organizerPercentInput: 'group-panel-organizer-percent-input',
    organizerPrice: 'group-panel-organizer-price',
    percentInput: 'group-panel-percent-input',
    price: 'group-panel-price',
    continueToPickControl: 'group-panel-continue-to-pick-control',
    pickControlRadio: 'group-panel-pick-control-radio',
    pickControlRow: 'group-panel-pick-control-row',
    submitButton: 'group-panel-create-entry',
  },
};
